import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import 'vant/lib/index.css';
import router from './router'
import i18n from './i18n/index'
require('es6-promise').polyfill()
require('isomorphic-fetch')
import filters from './assets/js/filters'
import walletFilter from './config/wallet'
// elemeent-ui组件
import './config/elementConfig.js'
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) //注册全局filter；
})
Object.keys(walletFilter).forEach(key => {
  Vue.filter(key, walletFilter[key]) //注册全局filter；
})

window.globalStore = new Vue({
  data: {
    menuVisible: false
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')